import classNames from 'classnames';
import TableRow from '@alltrails/denali/components/TableRow';
import Place from '@alltrails/denali/icons/Place';
import { CoordinatesResult } from '../../types/algoliaResultTypes';
import styles from './styles/styles.module.scss';

type CoordinatesResultContentProps = {
  result: CoordinatesResult;
};

const CoordinatesResultContent = ({ result }: CoordinatesResultContentProps) => {
  const icon = (
    <div className={styles.iconContainer}>
      <Place color="--color-text-secondary" />
    </div>
  );

  return (
    <TableRow
      className={classNames(styles.listItemContent, styles.noDescription)}
      leftContent={icon}
      label={
        <div className={styles.label}>
          {result.latitude}, {result.longitude}
        </div>
      }
      description={result.type}
    />
  );
};

export default CoordinatesResultContent;
